import React, { ReactNode } from 'react';

type Props = {
  icon: string;
  hint?: boolean;
  hintMessage?: ReactNode;
  onButtonClick: () => void;
};

export const FloatSidebarButton = ({
  hint = false,
  hintMessage = '',
  icon,
  onButtonClick
}: Props) => {
  return (
    <div
      data-testid="float-sidebar-button"
      onClick={onButtonClick}
      className={`float-button ${icon} ${
        hint ? 'hint' : ''
      } center-right module-color`}
    >
      <div className="hint-content">{hintMessage}</div>
    </div>
  );
};
